<template>
  <div>
    <div
      v-if="regularCards.length"
      class="module-container"
    >
      <ModuleCard
        v-for="card in regularCards"
        :key="card.name"
        :title="card.title"
        :subheader="card.subheader"
        :description="card.description"
        :module-route="card.route"
        :disabled="card.disabled"
        :icon-src="card.icon"
      ></ModuleCard>
    </div>
    <hr
      v-if="regularCards.length && adminCards.length"
      class="module-divider"
    />
    <div
      v-if="adminCards.length"
      class="module-container"
    >
      <ModuleCard
        v-for="card in adminCards"
        :key="card.name"
        :title="card.title"
        :subheader="card.subheader"
        :description="card.description"
        :module-route="card.route"
        :disabled="card.disabled"
        :icon-src="card.icon"
      ></ModuleCard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import safetyIcon from '@/assets/images/infusion-safety-icon.svg';
import formularyIcon from '@/assets/images/formulary-icon.svg';
import nicIcon from '@/assets/images/nic-initials-wht.webp';
import { USER_CONFIG_CAPABILITY, SSO_CONFIG_CAPABILITY, DEBUG_ADMIN_CAPABILITY } from '@/lib/identity-methods';
import ModuleCard from './ModuleCard.vue';

export default {
  name: 'LandingPage',
  components: {
    ModuleCard,
  },
  data() {
    return {
      cards: [
        {
          name: 'safety',
          title: `Med O.S.<sup style="font-size: 0.6em; top: -0.5em;">®</sup> for <br /> Infusion Safety`,
          subheader: 'Translate data to insights, interventions and impact',
          description:
            'Transform your infusion data into actionable interventions to prevent medication errors, enhance patient safety, and give clinicians their time back',
          route: '/safety',
          icon: safetyIcon,
        },
        {
          name: 'formulary',
          title: `Med O.S.<sup style="font-size: 0.6em; top: -0.5em;">®</sup> for <br /> IV Formulation Management`,
          subheader: 'Reduce IV Drug Waste & Optimize Pharmacy Operations',
          description:
            ' Unlock the full value of your administration data and learn from our national network to optimize drug purchase and preparation decisions ',
          route: '/ivformulation',
          disabled: true,
          icon: formularyIcon,
        },
        {
          name: 'nic',
          title: `National Infusion Collaborative<sup style="font-size: 0.6em; top: -0.5em;">™</sup>`,
          subheader: 'Connect with peers, share best practices, and access national benchmarking data',
          description: ' Connect with peers, share best practices, and access national benchmarking data ',

          disabled: true,
          icon: nicIcon,
        },
        {
          name: 'user-admin',
          title: `User Admin`,
          subheader: `Administration control panel`,
          description: 'Manage users permissions and capabilities',
          route: '/user-admin',
          icon: 'mdi-shield-account',
          capabilities: [USER_CONFIG_CAPABILITY, SSO_CONFIG_CAPABILITY],
          isAdmin: true,
        },
        {
          name: 'debug',
          title: `Debug`,
          subheader: 'Debug Administrations',
          description: 'Tools for Sentry Testing and User Troubleshooting',
          route: '/debug',
          icon: 'mdi-bug',
          capabilities: [DEBUG_ADMIN_CAPABILITY],
          isAdmin: true,
        },
      ],
    };
  },
  computed: {
    // Leaving in case we want to allow for a default module in the future
    // defaultRoute() {
    //   if (this.multiFactorRequired) {
    //     return '/profile';
    //   }
    //   return '/safety';
    // },
    ...mapGetters(['multiFactorRequired', 'userHasCapability', 'tenant']),
    visibleCards() {
      const formularyTenants = ['demo', 'demop'];

      return this.cards
        .filter((card) => {
          if (!card.capabilities || card.capabilities.length === 0) return true;

          return card.capabilities.some((cap) => this.userHasCapability(cap));
        })
        .map((card) => ({
          ...card,
          disabled:
            card.name === 'formulary' ? !formularyTenants.includes(this.tenant?.name?.toLowerCase()) : card.disabled,
        }));
    },
    regularCards() {
      return this.visibleCards.filter((c) => !c.isAdmin);
    },
    adminCards() {
      return this.visibleCards.filter((c) => c.isAdmin);
    },
  },
  watch: {
    defaultRoute(route) {
      if (this.multiFactorRequired) {
        this.$router.push({ path: route });
      }
    },
  },
  mounted() {
    if (this.multiFactorRequired) {
      this.$router.push({ path: '/profile' });
      // this.state = 'loaded';
    }
  },
};
</script>

<style lang="scss" scoped>
.module-container {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 64px 128px;
}

.module-divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 16px 64px;
}
</style>
